// extracted by mini-css-extract-plugin
export var containerFaq = "FaqContainer-module--container-faq--0518a";
export var devProcessImage = "FaqContainer-module--dev-process-image--d2666";
export var imageBox = "FaqContainer-module--image-box--bec91";
export var imagePopup = "FaqContainer-module--image-popup--38317";
export var imagePopupCloseBtn = "FaqContainer-module--image-popup-close-btn--194e3";
export var mainBox = "FaqContainer-module--main-box--132ce";